import { useState } from 'react';
import { cn } from '@/utils/cn';
import { cardImageStyles, styles } from '../../vehicle-card.styles';
import { SEM_FOTO_IMAGE_URL } from './card-image.constants';
import { myAdsTestId } from '../../../../utils';
import type { TCardImageConfig } from '../../vehicle-card.types';

const CardImage = ({ adId, src, alt, layout, vehicleType }: TCardImageConfig) => {
	const [isLoaded, setIsLoaded] = useState(false);
	const [hasError, setHasError] = useState(false);

	const showPlaceholder = !src || hasError;
	const placeholderSrc = SEM_FOTO_IMAGE_URL[vehicleType ?? 'car'];

	return (
		<div className={cardImageStyles({ layout })} data-testid={myAdsTestId.cardImage(adId)}>
			<div className={styles.imageWrapper}>
				{showPlaceholder ? (
					<img
						src={placeholderSrc}
						alt={alt}
						className={cn(styles.image, styles.imageVisible)}
						loading="lazy"
					/>
				) : (
					<>
						{!isLoaded && <div className={styles.imageSkeleton} aria-hidden="true" />}
						<img
							src={src}
							alt={alt}
							className={cn(styles.image, isLoaded ? styles.imageVisible : styles.imageHidden)}
							loading="lazy"
							onLoad={() => setIsLoaded(true)}
							onError={() => setHasError(true)}
						/>
						{isLoaded && <div className={styles.imageGradient} />}
					</>
				)}
			</div>
		</div>
	);
};

CardImage.displayName = 'CardImage';

export { CardImage };
